export function initScripts(element, containerSelector) {
	const container = document.querySelector(containerSelector || 'head');
	const scripts = element.querySelectorAll('script');

	for (let a = 0; a < scripts.length; a++) {
		const script = document.createElement('script');

		// Add all attributes to new script
		for (let b = 0; b < scripts[a].attributes.length; b++) {
			const attrib = scripts[a].attributes[b];

			if (attrib.specified) {
				script.setAttribute(attrib.name, attrib.value);
			}
		}

		// Add innerHTML if exists
		if (scripts[a].innerHTML) {
			script.innerHTML = scripts[a].innerHTML;
		}

		container.appendChild(script);
	}
}
